export enum Feature {
  DASHBOARD_VIEW,

  MEMBERS_VIEW,
  MEMBER_VIEW,
  MEMBER_EDIT,
  MEMBER_CUSTOM_DATA_EDIT,

  ALLOW_LIST_VIEW,
  ALLOW_LIST_CREATE,
  ALLOW_LIST_EDIT,
  ALLOW_LIST_DELETE,

  AUDIENCES_VIEW,
  AUDIENCE_VIEW,
  AUDIENCE_CREATE,
  AUDIENCE_EDIT,
  AUDIENCE_EDIT_VIEW_ONLY,
  AUDIENCE_EXPORT,
  AUDIENCE_ARCHIVE,
  AUDIENCE_ACTIVATE,

  AWARDS_VIEW,
  AWARD_VIEW,
  AWARD_CREATE,
  AWARD_EDIT,
  AWARD_EDIT_VIEW_ONLY,
  AWARD_DELETE,

  OFFERS_VIEW,
  OFFER_VIEW,
  OFFER_CREATE,
  OFFER_EDIT,

  PRODUCT_GROUPS_VIEW,
  PRODUCT_GROUP_VIEW,
  PRODUCT_GROUP_CREATE,
  PRODUCT_GROUP_EDIT,
  PRODUCT_GROUP_DELETE,

  WALLETS_VIEW,
  WALLET_VIEW,
  WALLET_CREATE,
  WALLET_EDIT,
  WALLET_ARCHIVE,
  WALLET_EDIT_VIEW_ONLY,

  SURVEYS_VIEW,
  SURVEY_VIEW,
  SURVEY_CREATE,
  SURVEY_EDIT,
  SURVEY_ARCHIVE,
  SURVEY_EDIT_VIEW_ONLY,

  SEGMENTS_VIEW,
  SEGMENT_VIEW,
  SEGMENT_CREATE,
  SEGMENT_EDIT,
  SEGMENT_EDIT_VIEW_ONLY,
  SEGMENT_DELETE,

  CAMPAIGNS_VIEW,
  CAMPAIGN_VIEW,
  CAMPAIGN_CREATE,
  CAMPAIGN_EDIT,
  CAMPAIGN_DELETE,

  CAMPAIGN_COMPONENTS_VIEW,
  CAMPAIGN_COMPONENT_VIEW,
  CAMPAIGN_COMPONENT_CREATE,
  CAMPAIGN_COMPONENT_EDIT,
  CAMPAIGN_COMPONENT_DELETE,
  CAMPAIGN_COMPONENT_EDIT_VIEW_ONLY,

  USER_MANAGEMENT_VIEW,
  USER_MANAGEMENT_CREATE,
  USER_MANAGEMENT_EDIT,

  TRANSACTIONS_VIEW,
  TRANSACTION_VIEW,

  CUSTOMERS_VIEW,

  // Locations (Site Management)
  LOCATIONS_VIEW,
  LOCATION_VIEW,
  LOCATION_CREATE,
  LOCATION_EDIT,
  LOCATION_EDIT_VIEW_ONLY,
  LOCATION_GROUP_CREATE,
  LOCATION_GROUP_EDIT,
  LOCATION_GROUP_EDIT_VIEW_ONLY,
  LOCATION_GROUP_DELETE,
  LOCATION_ISSUES_VIEW,
  LOCATION_ISSUE_EDIT,
  LOCATION_ISSUE_DELETE,
  LOCATION_ADD_TO_GROUP,

  DISPLAY_CATEGORIES_VIEW,
  DISPLAY_CATEGORY_VIEW,
  DISPLAY_CATEGORY_CREATE,
  DISPLAY_CATEGORY_EDIT,
  DISPLAY_CATEGORY_DELETE,

  PRODUCT_CATEGORIES_VIEW,
  PRODUCT_CATEGORY_VIEW,
  PRODUCT_CATEGORY_CREATE,
  PRODUCT_CATEGORY_EDIT,

  LOYALTY_EVENTS_VIEW,
  LOYALTY_EVENT_VIEW,
  LOYALTY_EVENT_CREATE,
  LOYALTY_EVENT_EDIT,
  LOYALTY_EVENT_DELETE,
  LOYALTY_EVENT_EDIT_VIEW_ONLY,

  GAMES_VIEW,
  GAME_VIEW,
  GAME_CREATE,
  GAME_EDIT,
  GAME_EDIT_VIEW_ONLY,

  REFERRAL_PROGRAM_VIEW,
  REFERRAL_PROGRAM_EDIT,
  REFERRAL_PROGRAM_EDIT_VIEW_ONLY,

  PROGRAM_MANAGEMENT_VIEW,

  TRIGGERED_MESSAGES_VIEW,
  TRIGGERED_MESSAGES_EDIT,
  TRIGGERED_MESSAGES_CREATE,
  TRIGGERED_MESSAGES_ARCHIVE,
  TRIGGERED_MESSAGES_VIEW_ONLY,

  MESSAGING_CENTER_VIEW,
  MESSAGING_CENTER_EDIT,
  MESSAGING_CENTER_CREATE,
  MESSAGING_CENTER_ARCHIVE,
  MESSAGING_CENTER_VIEW_ONLY,

  // These permissions are used to render Sidebar items
  // Later when the whole CC will migrate to the new Policy Based permissions approach
  // we have to rewrite the Sidebar items render logic
  RETAILER_NETWORKS_VIEW,
  RETAILER_NETWORK_SITE_ROLES_HOME_PAGE_VIEW,

  SCAN_DATA_VIEW,
  SCAN_DATA_EDIT,
  SCAN_DATA_DOWNLOAD_CSV,
  SCAN_DATA_SUBMIT_WEEKLY_FILE,
  SCAN_DATA_SUBMISSION_GROUPS_VIEW,
  SCAN_DATA_SUBMISSION_GROUPS_CREATE,
  SCAN_DATA_SUBMISSION_GROUPS_EDIT,
  SCAN_DATA_SUBMISSION_GROUPS_ADD_REMOVE_LOCATIONS,

  TOUCHPOINT_VIEW,
  TOUCHPOINT_AD_SETS_VIEW,
  TOUCHPOINT_AD_SET_VIEW,
  TOUCHPOINT_AD_SET_CREATE,
  TOUCHPOINT_AD_SET_EDIT,
  TOUCHPOINT_AD_SET_DELETE,
  TOUCHPOINT_ASSETS_VIEW,
  TOUCHPOINT_ASSET_VIEW,
  TOUCHPOINT_ASSET_CREATE,
  TOUCHPOINT_ASSET_EDIT,
  TOUCHPOINT_ASSET_DELETE,
  TOUCHPOINT_DEFAULT_SCREENS_VIEW,
  TOUCHPOINT_DEFAULT_SCREEN_VIEW,
  TOUCHPOINT_DEFAULT_SCREEN_CREATE,
  TOUCHPOINT_DEFAULT_SCREEN_EDIT,
  TOUCHPOINT_DEFAULT_SCREEN_EDIT_VIEW_ONLY,
  TOUCHPOINT_DEFAULT_SCREEN_DELETE,

  DRIVE_INSIGHTS_VIEW,
  TOBACCO_API_OFFERS_VIEW,
  TOBACCO_API_OFFERS_EDIT,

  RETAILER_NETWORK_USER_MOBILE_PHONE_VIEW,
}
